import { ActionReducerMap } from '@ngrx/store';
import { AppState } from '@shared-models';
import { bicyclesReducer } from './bicycles.reducer';
import { shoppingCartReducer } from './shopping-cart.reducer';
import { sunbedReducer } from './sunbed.reducer';

export const reducers: ActionReducerMap<AppState> = {
  shoppingCart: shoppingCartReducer,
  bicycles: bicyclesReducer,
  sunbeds: sunbedReducer,
};
